export default __webpack_public_path__ + "3a51101feaba422943c08ad18863fad0.png";